/**
 * What a typed address looked like, without the address.
 *
 * A failed lookup is only diagnosable if the row says whether the text was a
 * whole address or a street line on its own -- the server refuses a street with
 * no city or ZIP by design. Counts and flags only: the text itself is personal
 * and never leaves the browser in a tracking row.
 */
export interface TypedAddressShape {
  words: number;
  has_number: boolean;
  /** A US ZIP (12345, 12345-6789) or a Canadian postal code (A1A 1A1). */
  has_postal: boolean;
  has_comma: boolean;
}

const US_ZIP = /\b\d{5}(?:-\d{4})?\b/;
const CA_POSTAL = /\b[a-z]\d[a-z] ?\d[a-z]\d\b/i;

export function typedAddressShape(text: string): TypedAddressShape {
  const trimmed = text.trim();
  return {
    words: trimmed === '' ? 0 : trimmed.split(/\s+/).length,
    has_number: /\d/.test(trimmed),
    has_postal: US_ZIP.test(trimmed) || CA_POSTAL.test(trimmed),
    has_comma: trimmed.includes(','),
  };
}
